import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Home, Jobs, Form, Status, Login, Careers } from "./pages";
import Vendors from "./pages/vendors";
import { createBrowserHistory } from "history";
import Particles from "react-particles-js";
import NavBar from "./components/header";
import Crumbs from "./components/breadCrumbs";

const particlesOptions = {
  particles: {
    number: {
      value: 20,
      density: {
        enable: true,
        value_area: 1000,
      },
    },
    line_linked: {
      enable: false,
    },
    move: {
      speed: 1,
      out_mode: "out",
    },
    shape: {
      type: ["image", "circle"],
      image: [
        {
          src: require("./Images/logo.svg"),
          width: 100,
          height: 100,
        },
        {
          src: require("./Images/logo.svg"),
          width: 100,
          height: 100,
        },
      ],
    },
    color: {
      value: "#CCC",
    },
    size: {
      value: 100,
      random: true,
      anim: {
        enable: true,
        speed: 4,
        size_min: 10,
        sync: false,
      },
    },
  },
  retina_detect: true,
};

let hist = createBrowserHistory();
export default class APP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSignedIn: false,
      currentApplicant: null,
      pass: "",
      selectedJob: null,
    };
  }

  setloginStatusTrue = (applicant, password) => {
    console.log("ApplicantForm Submitted");
    this.setState({
      currentApplicant: applicant,
      pass: password,
      isSignedIn: true,
    });
  };

  setSelectedJob = (job) => {
    this.setState({
      selectedJob: job,
    });
  };

  logoutSession = () => {
    this.setState({
      isSignedIn: false,
      currentApplicant: null,
      selectedJob: null,
      currentCrumb: 0,
    });
  };

  render() {
    const { isSignedIn, currentApplicant, selectedJob, pass } = this.state;
    return (
      <Router history={hist}>
        <Particles className="particles" params={particlesOptions} />
        <div className="PageHeader">
          <NavBar
            className="homeHeder"
            isSignedIn={isSignedIn}
            logoutSession={this.logoutSession}
            currentApplicant={currentApplicant}
          />
        </div>
        <div className="PageScreen">
          <Switch>
            <Route path={"/"} exact name={"Home"} component={() => <Home />} />
            <Route
              path={"/careers"}
              exact
              name={"Home"}
              component={() => <Careers />}
            />
            <Route
              path={"/login"}
              exact
              name={"Login"}
              component={() =>
                isSignedIn ? (
                  <div>
                    <Status currentApplicant={currentApplicant} pass={pass} />
                  </div>
                ) : (
                  <Login setloginStatusTrue={this.setloginStatusTrue} />
                )
              }
            />
            <Route
              path={"/careers/jobs"}
              exact
              name={"Jobs"}
              component={() => (
                <div>
                  <br />
                  <Crumbs currentCrumb={0} />
                  <Jobs setSelectedJob={this.setSelectedJob} />
                </div>
              )}
            />
            <Route
              path={"/careers/apply@w4work"}
              exact
              name={"Form"}
              component={() => (
                <>
                  {currentApplicant === null ? (
                    <div className="formPage">
                      <br />
                      <Crumbs
                        currentCrumb={currentApplicant === null ? 1 : 2}
                      />
                      <Form
                        selectedJob={selectedJob}
                        setloginStatusTrue={this.setloginStatusTrue}
                      />
                    </div>
                  ) : (
                    <Status currentApplicant={currentApplicant} />
                  )}
                </>
              )}
            />
            <Route
              path={"/careers/status"}
              exact
              name={"Status"}
              component={() => (
                <div>
                  <Status currentApplicant={currentApplicant} />
                </div>
              )}
            />
            <Route
              path={"/vendors"}
              exact
              name={"Vendors"}
              component={() => (
                <div>
                  <Vendors />
                </div>
              )}
            />

            <Route path="*" component={Home} />
          </Switch>
        </div>
      </Router>
    );
  }
}
